import api from './api';

export async function getExchangeRateForDate(date) {
  const response = await api.get('/exchange-rates/for-date', {
    params: { date },
  });
  return response.data;
}
